import axios from "axios";

const entente = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

export default entente;
